import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import { Store } from 'redux'

import App from './App'

import BuildtimeConfigBuilder from '~/config/services/BuildtimeConfigBuilder'
import RuntimeConfigBuilder from '~/config/services/RuntimeConfigBuilder'
import AppDepsBuilder from '~/core/services/AppDepsBuilder'
import createAppStore from '~/core/store'
import { RootState } from '~/core/store/root.reducer'

interface WindowWithCypress extends Window {
  Cypress?: unknown
  store?: unknown
}

async function startApp() {
  const buildtimeConfig = new BuildtimeConfigBuilder().getBuildtimeConfig()
  const runtimeConfig = await new RuntimeConfigBuilder().getRuntimeConfig()
  const appDeps = new AppDepsBuilder(buildtimeConfig, runtimeConfig).buildAppDeps()

  // Register SW
  await appDeps.authService.init()

  const { store, persistor } = createAppStore(appDeps, undefined)

  ReactDOM.render(
    <Provider store={(store as unknown) as Store<RootState>}>
      <App appDeps={appDeps} persistor={persistor} />
    </Provider>,
    document.getElementById('root'),
  )

  const windowWithCypress: WindowWithCypress = window
  if (windowWithCypress.Cypress) {
    windowWithCypress.store = store
  }
}

startApp()
